<template>
  <div id="lineSetting">
    <div class="lineContent">
      <div class="left">

        <div id="start" class="start">
          <div class="title flex-between">
            <h2 class="formTitle">上车站点</h2>
            <span>共{{ form.stationVoList[0].stationRail.length }}个站点</span>
          </div>

          <div class="places">
            <div class="places-item" :class="{ focus: active.place == 0 && active.index == index }"
              v-for="(item, index) in form.stationVoList[0].stationRail" :key="index" @click="clickStartItem(index)">
              <span
                :class="item.stationType == 1 ? 'places-item-type places-item-type-fixed' : 'places-item-type places-item-type-range'">{{
                  item.stationType == 1 ? '定点' : '上门' }}</span>
              <span class="places-item-name">{{ item.stationName }}</span>
            </div>
          </div>
        </div>

        <div class="end">
          <div class="title flex-between">
            <h2  class="formTitle">下车站点</h2>
            <span>共{{ form.stationVoList[1].stationRail.length }}个站点</span>
          </div>

          <div class="places">
            <div v-for="(item, index) in form.stationVoList[1].stationRail" :key="index" :tabindex="index"
              :class="{ focus: active.place == 1 && active.index == index }" class="places-item"
              @click="clickEndItem(index)">
              <span
                :class="item.stationType == 1 ? 'places-item-type places-item-type-fixed' : 'places-item-type places-item-type-range'">{{
                  item.stationType == 1 ? '定点' : '上门' }}</span>
              <span class="places-item-name">{{ item.stationName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div id="mapCtx"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "lineSetting",
  data() {
    return {
      id: this.$route.query.id,
      // 起始地点集合
      form: {
        stationVoList: [
          // 保存地址的经纬度和名称
          {
            stationRail: [
              {
                stationType: 1,
                stationName: null,
                marker: null,
                polygon: null,
              },
            ],
          },
          {
            stationRail: [
              {
                stationType: 1,
                stationName: null,
                marker: null,
                polygon: null,
              },
            ],
          },
        ],
      },
      active: {
        place: null,
        index: null,
      },
      // 地图上下文
      mapCtx: null,
      polygonColor: {
        startBKGD: "#deefff",
        startBKGDFC: "#0288FF",
        startBD: "#a0d1ff",
        startBDFC: "#68b6ff",
        endBKGD: "#deffe7",
        endBKGDFC: "#40ff02",
        endBD: "#228b2252",
        endBDFC: "#228b2236",
      },
    };
  },
  computed: {
    // 当前操作的目标地址对象getInfoOverlay
    targetPlace() {
      return this.form.stationVoList[this.active.place].stationRail[this.active.index];
    },
  },
  watch: {},
  async mounted() {
    this.initMap();
  },
  methods: {
    /* 初始化地图 */
    initMap() {
      this.mapCtx = new AMap.Map("mapCtx", {
        mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
        resizeEnable: true,
        zoom: 14,
        doubleClickZoom: false,
        center: new AMap.LngLat(104.065861, 30.657401),
      });

      // 渲染完地图再请求数据
      this.getInfo();
    },
    /* 获取线路详情 */
    async getInfo() {
      if (!this.id) {
        return false;
      }
      let url = "/api/v1/manage/line/" + this.id;
      let { code, data } = await this.$axios.get(url);
      if (code === 1 && data.stationVoList) {
        this.form = { ...data };
        this.getInfoOverlay();
      }
    },

    /* 获取详情后-覆盖物处理 */
    getInfoOverlay() {
      this.form.stationVoList.map((sr, srIndex) => {
        sr.stationRail.map((item, index) => {
          this.active = {
            place: srIndex,
            index,
          };
          if (item.stationType == 1) {
            this.formAddMarker(
              new AMap.LngLat(item.longitude, item.latitude),
              item.stationName
            );
          } else {
            this.formAddPolygon(JSON.parse(item.enclosureAddress));
          }
        });
      });
      // 初始没有聚焦
      this.active = {
        place: null,
        index: null,
      };
      this.mapCtx.setFitView();
    },

    /* 聚焦目标地址变化，覆盖物重新渲染 */
    placeChange() {
      if (this.active.place == 0) {
        // 若当前操作的是起点地址
        this.form.stationVoList[0].stationRail.map((item, index) => {
          if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.startBKGD,
              strokeColor: this.polygonColor.startBD,
            });
          }

          // 然后加深目标地址的颜色，移动位置达成聚焦
          if (index == this.active.index) {
            if (item.marker) {
              this.mapCtx.setFitView(
                item.marker,
                true,
                [200, 200, 200, 200],
                17
              );
            } else if (item.polygon) {
              item.polygon.setOptions({
                fillOpacity: 0.3,
                fillColor: this.polygonColor.startBKGDFC,
                strokeColor: this.polygonColor.startBDFC,
              });
              this.mapCtx.setFitView(
                item.polygon,
                true,
                [200, 200, 200, 200],
                16
              );
            }
          }
        });

        // 其他范围类型的终点颜色也变浅
        this.form.stationVoList[1].stationRail.map((item) => {
          if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.endBKGD,
              strokeColor: this.polygonColor.endBD,
            });
          }
        });
      } else if (this.active.place == 1) {
        this.form.stationVoList[1].stationRail.map((item, index) => {
          if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.endBKGD,
              strokeColor: this.polygonColor.endBD,
            });
          }

          // 然后加深目标地址的颜色，移动位置达成聚焦
          if (index == this.active.index) {
            if (item.marker) {
              this.mapCtx.setFitView(
                item.marker,
                true,
                [200, 200, 200, 200],
                17
              );
            } else if (item.polygon) {
              item.polygon.setOptions({
                fillOpacity: 0.3,
                fillColor: this.polygonColor.endBKGDFC,
                strokeColor: this.polygonColor.endBDFC,
              });
              this.mapCtx.setFitView(
                item.polygon,
                true,
                [200, 200, 200, 200],
                16
              );
            }
          }
        });

        this.form.stationVoList[0].stationRail.map((item) => {
          if (item.stationType == 2 && item.polygon) {
            item.polygon.setOptions({
              fillOpacity: 0.5,
              fillColor: this.polygonColor.startBKGD,
              strokeColor: this.polygonColor.startBD,
            });
          }
        });
      }
    },

    /**
     * 绘制marker点覆盖物 => form添加站点(Marker)
     * @lnglat       经纬度
     * @stationName  准确地点名称
     */
    formAddMarker(lnglat, stationName) {
      // 高德地图添加marker
      let content = `<div class="markerLabel ${this.active.place == 0 ? "startFC" : "endFC"}">${stationName}</div>`;
      let Mark = new AMap.Marker({
        map: this.mapCtx, // 地图实例对象
        position: lnglat, // 标记位置
        animation: "AMAP_ANIMATION_DROP", // 标记掉落效果
        icon:
          this.active.place == 0
            ? require("@/assets/img/markerBegin.png")
            : require("@/assets/img/markerEnd.png"),
        offset: new AMap.Pixel(-2, 0),
      });
      Mark.setLabel({
        content: content,
        direction: "top",
        offset: new AMap.Pixel(0, -6),
      });

      if (this.targetPlace.marker) {
        this.mapCtx.remove(this.targetPlace.marker);
        this.targetPlace.marker = null;
      }
      this.targetPlace.marker = Mark
    },

    /**
     * 处理绘制的多边形 => form添加围栏(多边形)
     * @corners   多边形原始角数据
     */
    formAddPolygon(corners) {
      let polygon = new AMap.Polygon({
        map: this.mapCtx,
        path: corners,
        fillOpacity: 0.5,
        strokeOpacity: 1,
        fillColor:
          this.active.place == 0
            ? this.polygonColor.startBKGD
            : this.polygonColor.endBKGD,
        strokeColor:
          this.active.place == 0
            ? this.polygonColor.startBDFC
            : this.polygonColor.endBDFC,
      });
      // 生成并添加围栏
      this.targetPlace.polygon = polygon;
    },

    /**
     * 点击一个起点
     * @item   起点地址对象
     * @index  起点地址下标
     * @action 是否启动鼠标绘画事件
     */
    clickStartItem(index) {
      // 更新当前行为
      this.active = {
        place: 0,
        index,
      };
      this.placeChange();
    },

    /* 点击一个终点 */
    clickEndItem(index) {
      this.active = {
        place: 1,
        index,
      };
      this.placeChange();
    },
  },
};
</script>

<style lang="less" scoped>
#lineSetting {
  box-sizing: border-box;

  .lineContent {
    height: calc(100vh - 316px);
    display: flex;
    justify-content: space-between;


    .left {
      box-sizing: border-box;
      width: 30%;
      margin-right: 20px;
      height: 100%;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 3px !important;
        background-color: rgba(255, 0, 0, 0) !important;
      }

      .title {
        font-size: 12px;

        span {
          color: #999;
        }
      }

      h2 {
        line-height: 1;
        text-indent: 1rem;
        border-left: 0.5rem solid #0289ff6c;
      }

      .start {
        margin-bottom: 4rem;
      }

      .end {
        margin-bottom: 4rem;

        h2 {
          border-color: #228b226c;
        }


        .places-item.focus {
          background-color: rgb(242, 255, 240);
          border: 1px solid #228b226c;
        }
      }

      .places {
        &-item {
          padding: 16px;
          background-color: #FAFAFA;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          border: 1px solid #FAFAFA;

          &-name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &-type {
            margin-right: 8px;
            width: 30px;
            padding: 4px;
            border-radius: 4px;
            font-size: 12px;
            text-align: center;

            &-fixed {
              background-color: #DBEAFE;
              color: #1E40AF;
            }

            &-range {
              background-color: #DCFCE7;
              color: #166534;
            }
          }

          &.focus {
            background-color: aliceblue;
            border: 1px solid #0289ffbb;
            border-radius: 4px;
          }
        }
      }
    }

    .right {
      width: 70%;
      box-sizing: border-box;
      position: relative;

      &-top {
        text-align: right;
        padding: 0 0 10px 0;
      }

      #mapCtx {
        width: 100%;
        height: 100%;
      }

      /deep/ .markerLabel {
        padding: 1rem 1.5rem;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        font-size: 1.5rem;
        color: #ffffff;
        box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

        &.start {
          background-color: #0289ffbb;
        }

        &.startFC {
          background-color: #0289ff;
        }

        &.end {
          background-color: #228b22bb;
        }

        &.endFC {
          background-color: #228b22;
        }
      }
    }
  }
}
</style>